import { preview } from '@/components/form/preview'

import { BulkDriverViewHeader } from './components/BulkDriverViewHeader'

import { useDriversValues } from './hooks/useDriversValues'
import { useTexts } from './hooks/useTexts'

type DriverViewProps = {
  drivers: uui.domain.client.rm.ExtendedDriver[]
}

export function BulkDriverView(props: DriverViewProps) {
  const { drivers } = props
  const { titles, labels, values } = useTexts()
  const driversValues = useDriversValues(drivers)

  return (
    <preview.Root applyPendingFitMapOnMount={false} header={<BulkDriverViewHeader {...props} />}>
      <preview.SectionTitle>{titles.driverApp}</preview.SectionTitle>

      <preview.Field label={labels.mobileFutureDaysVisibility}>
        {values.mobileFutureDaysVisibility(driversValues.mobileFutureDaysVisibility)}
      </preview.Field>

      <preview.Field label={labels.summarizeFutureMobileRoute}>
        {values.summarizeFutureMobileRoute(driversValues.summarizeFutureMobileRoute)}
      </preview.Field>
    </preview.Root>
  )
}
